//Library Imports
import React from 'react'
import PageShell from '../../PageShell'
import Loadable from 'react-loadable'
import Loading from '../../../Loading'

const LoadableApp = Loadable({
  loader: () => import('./Sections/AppSection'),
  loading: Loading,
})

const LoadableDashboard = Loadable({
  loader: () => import('./Sections/DashboardSection'),
  loading: Loading,
})

const PatientInsights = () => (
    <PageShell
        title="Patient Insights"
        blurb="We work to understand your patient's unique perception of the world"
        img={require('assets/img/insights-bg.jpg')}
        components={[<LoadableApp key={0} />, <LoadableDashboard key={1} />]}
    />
)

export default PatientInsights



// WEBPACK FOOTER //
// ./src/views/Features/PatientInsights/PatientInsights.jsx